<div #container class="video-view">
    <video #target class="video-js video" controls preload="none"></video>  
    <!--
    <div class="video-controls">
        <button mat-button (click)="this.player.requestFullscreen()">Tela cheia</button>
    </div>
    -->
</div>
